export const localization = {
  pt: {
    title: 'Restaurar arquivo da base de conhecimento',
    subtitle: 'Selecione uma versão anterior para atualizar a base de conhecimento atual.',
    tableHeaders: {
      document: 'Documento',
      lastUpdate: 'Última atualização',
    },
    at: 'às',
    by: 'Por',
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    successToast: {
      title: 'Conteúdo restaurado',
      message: 'O conteúdo foi salvo e está disponível no catálogo.',
    },
    errorToast: {
      title: 'Falha ao restaurar o conteúdo',
      message: 'Não foi possível salvar o conteúdo. Tente novamente.',
    },
  },
  en: {
    title: 'Restore knowledge base file',
    subtitle: 'Select a previous version to update the current knowledge base.',
    tableHeaders: {
      document: 'Document',
      lastUpdate: 'Last updated',
    },
    at: 'at',
    by: 'By',
    cancelButton: 'Cancel',
    saveButton: 'Save',
    successToast: {
      title: 'Content restored',
      message: 'The content has been saved and is available in the catalog.',
    },
    errorToast: {
      title: 'Failed to restore content',
      message: 'Could not possibly restore the selected version. Please try again.',
    },
  },
  es: {
    title: 'Restaurar archivo de la base de conocimiento',
    subtitle: 'Selecciona una versión anterior para actualizar la base de conocimiento actual.',
    tableHeaders: {
      document: 'Documento',
      lastUpdate: 'Última actualización',
    },
    at: 'a las',
    by: 'Por',
    cancelButton: 'Cancelar',
    saveButton: 'Salvar',
    successToast: {
      title: 'Contenido restaurado',
      message: 'El contenido ha sido guardado y está disponible en el catálogo.',
    },
    errorToast: {
      title: 'Error al restaurar contenido',
      message: 'No se pudo restaurar la versión seleccionada. Inténtalo de nuevo.',
    },
  },
};
